import Vue from 'vue'
import $https from '@/plugins/axios'
import cookie from '@/utils/Tools'

const obtainTheme = (themeName) => {
  return new Promise(resolve => {
    if (process.env.NODE_ENV === 'production') {
      const theme = themeName
      const themeId = 'theme_' + themeName
      const themeElement = document.getElementById(themeId)
      if (theme && theme !== 'default') {
        if (!themeElement) {
          var linkDom = document.createElement('link')
          linkDom.id = themeId
          linkDom.type = 'text/css'
          linkDom.rel = 'stylesheet'
          linkDom.href = `/static/css/${theme}.css`
          const head = document.getElementsByTagName('head')[0]
          head.appendChild(linkDom)
          linkDom.onload = () => {
            resolve()
          }
        } else {
          resolve()
        }
      } else {
        resolve()
      }
    } else {
      resolve()
    }
  })
}

let state = {
  company: null
}

const getters = {
  company: state => {
    return state.company
  }
}

const mutations = {
  SET_COMPANY: (state, company) => {
    state.company = company
  },
  UPDATE_COMPANY: (state, company) => {
    for (const property in company) {
      Vue.set(state.company, property, company[property])
    }
  }
}

const actions = {
  async GetCompanyInfo ({ commit }) {
    let companyId = cookie.getCookie('companyId')
    const responseData = await $https.axios({
      method: 'get',
      url: 'companyInfo/getCompanyInfo',
      params: { id: companyId }
    })
    if (!responseData.data.companySkin) {
      responseData.data.companySkin = 'default'
    }
    commit('SET_COMPANY', responseData.data)
    await obtainTheme(responseData.data.companySkin)
    return responseData.data
  },
  async UpdateCompanyInfo ({ commit }, companyData) {
    const fullscreenLoading = Vue.prototype.$loading({
      lock: true,
      text: '读取数据中......'
    })
    try {
      await $https.axios({ method: 'post', url: 'companyInfo/updateCompanyInfo', params: companyData })
      commit('UPDATE_COMPANY', companyData)
      await obtainTheme(companyData.companySkin)
      fullscreenLoading.close()
    } catch (e) {
      fullscreenLoading.close()
      throw e
    }
    return companyData
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/company.js